import * as React from "react";

function IndiaFlag() {
  return (
    <svg
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_494_7504)">
        <path
          d="M24.381 5.33777H0V0.433534C0 0.201391 0.188238 0.0131531 0.420381 0.0131531H23.9606C24.1928 0.0131531 24.381 0.201391 24.381 0.433534L24.381 5.33777Z"
          fill="#FAB446"
        />
        <path
          d="M23.9606 15.9869H0.420381C0.188238 15.9869 0 15.7987 0 15.5665V10.6623H24.381V15.5665C24.381 15.7987 24.1927 15.9869 23.9606 15.9869Z"
          fill="#73AF00"
        />
        <path d="M24.381 5.33766H0V10.6619H24.381V5.33766Z" fill="#F5F5F5" />
        <path
          d="M12.1905 10.2595C10.9446 10.2595 9.93103 9.24593 9.93103 8.00003C9.93103 6.75413 10.9446 5.7406 12.1905 5.7406C13.4364 5.7406 14.4499 6.75413 14.4499 8.00003C14.4499 9.24593 13.4364 10.2595 12.1905 10.2595ZM12.1905 6.16093C11.1763 6.16093 10.3514 6.98584 10.3514 8.00003C10.3514 9.01422 11.1763 9.83913 12.1905 9.83913C13.2046 9.83913 14.0296 9.01422 14.0296 8.00003C14.0296 6.98584 13.2046 6.16093 12.1905 6.16093Z"
          fill="#41479B"
        />
        <path
          d="M12.1906 8.25585C12.3321 8.25585 12.4467 8.14117 12.4467 7.9997C12.4467 7.85824 12.3321 7.74356 12.1906 7.74356C12.0491 7.74356 11.9344 7.85824 11.9344 7.9997C11.9344 8.14117 12.0491 8.25585 12.1906 8.25585Z"
          fill="#41479B"
        />
        <path
          d="M12.1904 8.03871L11.5394 8.10442L10.1411 8.03871V7.96185L11.5394 7.89613L12.1904 7.96185V8.03871Z"
          fill="#41479B"
        />
        <path
          d="M12.1902 8.03871L12.8411 8.10442L14.2394 8.03871V7.96185L12.8411 7.89613L12.1902 7.96185V8.03871Z"
          fill="#41479B"
        />
        <path
          d="M12.1518 7.99998L12.0861 7.34903L12.1518 5.95073H12.2286L12.2943 7.34903L12.2286 7.99998H12.1518Z"
          fill="#41479B"
        />
        <path
          d="M12.1518 7.99982L12.0861 8.65077L12.1518 10.0491H12.2286L12.2943 8.65077L12.2286 7.99982H12.1518Z"
          fill="#41479B"
        />
        <path
          d="M12.163 8.02697L11.6563 7.6132L10.714 6.57795L10.7683 6.52362L11.8036 7.46592L12.2173 7.97268L12.163 8.02697Z"
          fill="#41479B"
        />
        <path
          d="M12.1633 8.02725L12.5771 8.53402L13.6123 9.47631L13.6667 9.42197L12.7244 8.38673L12.2176 7.97296L12.1633 8.02725Z"
          fill="#41479B"
        />
        <path
          d="M12.1633 7.97268L12.5771 7.46592L13.6123 6.52362L13.6667 6.57795L12.7244 7.6132L12.2176 8.02697L12.1633 7.97268Z"
          fill="#41479B"
        />
        <path
          d="M12.163 7.97296L11.6563 8.38673L10.714 9.42197L10.7683 9.47631L11.8036 8.53402L12.2173 8.02725L12.163 7.97296Z"
          fill="#41479B"
        />
        <path
          d="M12.2053 8.03542L11.629 8.34523L10.312 8.81961L10.2826 8.74861L11.5493 8.1528L12.1758 7.96437L12.2053 8.03542Z"
          fill="#41479B"
        />
        <path
          d="M12.205 8.0352L12.8315 7.84677L14.0982 7.25096L14.0688 7.17996L12.7518 7.65434L12.1755 7.96415L12.205 8.0352Z"
          fill="#41479B"
        />
        <path
          d="M12.155 8.01489L11.8452 7.4386L11.3708 6.12165L11.4418 6.09222L12.0376 7.35894L12.2261 7.98546L12.155 8.01489Z"
          fill="#41479B"
        />
        <path
          d="M12.1548 8.01507L12.3432 8.64159L12.939 9.90831L13.01 9.87888L12.5356 8.56193L12.2258 7.98564L12.1548 8.01507Z"
          fill="#41479B"
        />
        <path
          d="M12.1758 8.0352L11.5493 7.84677L10.2826 7.25096L10.312 7.17996L11.629 7.65434L12.2053 7.96415L12.1758 8.0352Z"
          fill="#41479B"
        />
        <path
          d="M12.1755 8.03542L12.7518 8.34523L14.0688 8.81961L14.0982 8.74861L12.8315 8.1528L12.205 7.96437L12.1755 8.03542Z"
          fill="#41479B"
        />
        <path
          d="M12.1548 7.98546L12.3432 7.35894L12.939 6.09222L13.01 6.12165L12.5356 7.4386L12.2258 8.01489L12.1548 7.98546Z"
          fill="#41479B"
        />
        <path
          d="M12.155 7.98564L11.8452 8.56193L11.3708 9.87888L11.4418 9.90831L12.0376 8.64159L12.2261 8.01507L12.155 7.98564Z"
          fill="#41479B"
        />
        <path
          d="M12.1905 8.34559C12.3813 8.34559 12.536 8.19089 12.536 8.00006C12.536 7.80923 12.3813 7.65453 12.1905 7.65453C11.9997 7.65453 11.845 7.80923 11.845 8.00006C11.845 8.19089 11.9997 8.34559 12.1905 8.34559Z"
          fill="#F5F5F5"
        />
        <path
          d="M12.1905 8.20726C12.3049 8.20726 12.3976 8.1145 12.3976 8.00007C12.3976 7.88564 12.3049 7.79288 12.1905 7.79288C12.076 7.79288 11.9833 7.88564 11.9833 8.00007C11.9833 8.1145 12.076 8.20726 12.1905 8.20726Z"
          fill="#41479B"
        />
      </g>
      <defs>
        <clipPath id="clip0_494_7504">
          <rect width="24.381" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IndiaFlag;
